import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/axios.js';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    favoriteTotal: 0,
    auth: {},
    auth_order_type: [],  // 当前登录用户可选择的产品，抖音列表页使用
    is_product: false
  },
  mutations: {
    FAVORITETOTAL(state, num) {
      state.favoriteTotal = num
    },
    AUTH(state, obj) {
      state.auth = obj
    },
    AUTH_ORDER_TYPE(state, arr) {
      state.auth_order_type = arr
    },
    IS_PRODUCT(state, bool) {
      state.is_product = bool
    }
  },
  modules: {
    shoppingCart: {
      namespaced: true,
      state: {
        isInit: false,
        count:0,
      },
      actions: {
        async refreshCount({ state, commit, dispatch }){
          if (!state.isInit) {
            window.addEventListener('visibilitychange', (event)=> {
              if (document.visibilityState == 'visible') {
                console.log('触发 visible');
                const count = localStorage.getItem('shoppingCartCount')
                if (count) {
                  dispatch('changeCount',count)
                } else {
                  dispatch('refreshCount')
                }
              }
            });
            state.isInit = true
          }
          const params = {
            use_list: 0
          }
          const res = await axios.post(`/api.php?m=cart|api|gx&a=list&responsetype=crm`, params,{ headers: { showLoading: false }})
          commit('SET_COUNT',res?.data?.pageinfo?.total || 0)
        },
        changeCount({ commit },num){
          commit('SET_COUNT',num)
        },
      },
      mutations: {
        SET_COUNT(state,num){
          state.count = num
          localStorage.setItem('shoppingCartCount',num)
        }
      }
    }
  }
})